<template>
  <div class="container">
    <DynamicToolbar title="Driver Management" color="indigo" icon="mdi-account-details-outline" />

    <!-- ========================== -->
    <!-- Modal -->
    <transition name="fade">
      <div class="popup-modal" v-if="isVisible">
        <div class="window">
          <div style="text-align: center; padding: 15px;">
            <p style="margin-bottom: 30px;">Are you sure you want to offboard this driver?</p>
            <v-text-field v-model="endDate" label="Termination Date" type="date" outlined dense hide-details
              class="mt-2"></v-text-field>
            <div style="display: flex; justify-content: center; gap: 10px; margin-top: 20px;">
              <button style="width: 80px;" @click="offboardDriver()">Yes</button>
              <button style="width: 80px;" @click="isVisible = false">No</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- ========================== -->

    <!-- Navigation Buttons -->
    <div class="nav-buttons">
      <div class="form-group search-container" style="position: relative;">
        <input type="text" id="driver-search" v-model="searchQuery" placeholder="Search by driver name..."
          class="search-input" @focus="shouldShow = true" autocomplete="off" @change="emptyErrorsAndInfos()" />
        <span v-if="shouldShow" style="cursor: pointer; position: absolute; right: 15px; top: 10px;"
          @click="resetdriver()">X</span>

        <transition name="fade" :duration="300">
          <ul v-if="filteredDrivers.length && shouldShow" class="search-results">
            <li v-for="driver in filteredDrivers" :key="driver.id" @click="selectDriver(driver.id, driver.Name)">
              {{ driver.Name }}
            </li>
          </ul>
        </transition>
        <p style="position: absolute; width: 380px; padding: 10px;" v-if="!filteredDrivers.length && searchQuery"
          class="error">No drivers found.</p>
      </div>
      <button :class="{ active: selectedSection === 'add' }" @click="setSelectedSection('add')">
        Add Documents
      </button>
      <button :class="{ active: selectedSection === 'view' }" @click="setSelectedSection('view')">
        View Documents
      </button>
      <button @click="handleClickOffBoard()" class="fetch-button" style="background-color: red;">Offboard
        Driver</button>
    </div>




    <!-- Add Documents Section -->
    <section v-if="selectedSection == 'add'" class="card">
      <br>

      <hr>
      <div class="selection-container1">
        <div class="form-group">
          <label for="categories">Select Category:</label>
          <select id="categories" v-model="selectedCategory" @change="emptyErrorsAndInfos()">
            <option v-for="cat in categoryList" :key="cat.CategoryID" :value="cat.CategoryID">
              {{ cat.CategoryName }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="sub_categories">Select Subcategory:</label>
          <select id="sub_categories" v-model="selectedSubCategory" @change="emptyErrorsAndInfos()">
            <option v-for="subCat in filteredSubCategories" :key="subCat.SubCategoryID" :value="subCat.SubCategoryID">
              {{ subCat.SubCategoryType }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="application_type">Select Application Type: <span>*</span></label>
          <select id="application_type" required v-model="selectedApplicationType" @change="emptyErrorsAndInfos()">
            <option v-for="appType in filteredApplicationTypes" :key="appType.OnboardingID"
              :value="appType.DocumentName">
              {{ appType.DocumentName }}
            </option>
          </select>
        </div>
      </div>

      <div class="selection-container2" style="padding-top: 0px !important;">
        <div class="form-group">
          <label for="myfile">Select a file: <span>*</span></label>
          <input type="file" id="myfile" name="myfile" class="file-input" @change="emptyErrorsAndInfos()" accept=".pdf">
        </div>
      </div>

      <ul class="errors-list" v-if="errors.length !== 0">
        <li v-for="(error, index) in errors" :key="index">
          {{ error }}
        </li>
      </ul>

      <ul class="info-list" v-if="infos.length !== 0">
        <li v-for="(info, index) in infos" :key="index">
          {{ info }}
        </li>
      </ul>

      <button @click="postData()" class="submit-btn">Submit</button>

    </section>


    <section v-else-if="selectedSection === 'view'" class="card">
      <ListDriverDocuments :driverId="selectedDriver" :key="selectedDriver" />
    </section>


  </div>
</template>


<script>
import axios from "axios";
import ListDriverDocuments from "../../components/HR/DriverManagement/ListDriverDocuments.vue";
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import DocumentData from '../../Utils/json/driver_documents_struc.json'

export default {
  components: {
    ListDriverDocuments,
    DynamicToolbar,
  },
  data() {
    return {
      searchQuery: "",
      selectedDriver: null,
      selectedCategory: null,
      selectedSubCategory: null,
      selectedApplicationType: null,
      selectedSection: 'add',
      documentData: [],
      shouldShow: false,
      errors: [],
      infos: [],
      isVisible: false,
      endDate: null,

      driverList: [
      ],

      categoryList: [
        { CategoryID: null, CategoryName: "Select..." },
        { CategoryID: 1, CategoryName: "General" },
        { CategoryID: 2, CategoryName: "Training" },
        { CategoryID: 3, CategoryName: "Performance" },
        { CategoryID: 4, CategoryName: "Other" },
      ],

      subCategoryList: [
        { SubCategoryID: null, CategoryID: null, SubCategoryType: "Select..." },
        { SubCategoryID: 1, CategoryID: 1, SubCategoryType: "Onboarding" },
        { SubCategoryID: 2, CategoryID: 1, SubCategoryType: "Payrollinfo" },
        { SubCategoryID: 3, CategoryID: 2, SubCategoryType: "Policies" },
        { SubCategoryID: 4, CategoryID: 2, SubCategoryType: "Certifications" },
        { SubCategoryID: 5, CategoryID: 2, SubCategoryType: "TDG-WHMINS-CFA" },
        { SubCategoryID: 6, CategoryID: 2, SubCategoryType: "SafetyCourse" },
        { SubCategoryID: 7, CategoryID: 3, SubCategoryType: "Incidents" },
        { SubCategoryID: 8, CategoryID: 3, SubCategoryType: "Observations" },
        { SubCategoryID: 9, CategoryID: 4, SubCategoryType: "SafetyMeetings" },
        { SubCategoryID: 10, CategoryID: 4, SubCategoryType: "Miscellaneous" },
      ],

      onboardingList: DocumentData,
    };
  },

  computed: {
    filteredSubCategories() {
      return this.subCategoryList.filter(subCat => subCat.CategoryID === this.selectedCategory);
    },

    filteredApplicationTypes() {
      if (!this.selectedSubCategory || !this.selectedCategory) return this.onboardingList;
      return this.onboardingList.filter(appType => appType.SubCategoryID === this.selectedSubCategory);
    },

    filteredDrivers() {
      if (!this.searchQuery) return this.driverList;
      this.emptyErrorsAndInfos()
      return this.driverList.filter(driver =>
        driver.Name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },

  methods: {
    handleClickOffBoard() {
      if (this.selectedDriver) {
        this.isVisible = true
      } else {
        this.errors = []
        this.errors.push("Please select a driver")
      }
    },
    emptyInfosAndAdd(info) {
      this.infos = [info,]
    },
    emptyErrorsAndInfos() {
      this.errors = [];
      this.infos = [];
    },

    getDocumentID() {
      const found = this.onboardingList.find(appType => appType.ApplicationType === this.selectedApplicationType);
      return found ? found.OnboardingID : null;
    },

    setSelectedSection(option) {
      if (this.selectedSection === option) return;
      this.selectedSection = option;
    },

    selectDriver(id, name) {
      this.selectedDriver = id;
      this.searchQuery = name;
      this.shouldShow = false;
    },

    async postData() {
      if (!this.selectedDriver) this.errors.push("Please Select a Driver.");
      if (!this.selectedApplicationType) this.errors.push("Please Select an Application type.");

      const fileInput = document.getElementById("myfile");
      if (!fileInput.files.length) {
        this.errors.push("Please Upload a File.");
      } else {
        const file = fileInput.files[0];
        if (file.type !== "application/pdf") {
          this.errors.push("Only PDF files are allowed.");
        }
      }

      if (this.errors.length !== 0) return;

      const file = fileInput.files[0];

      try {
        const formData = new FormData();
        formData.append("SubCategoryName", this.selectedApplicationType);
        formData.append("IdentifierType", this.selectedDriver);
        formData.append("CategoryID", this.selectedCategory);
        formData.append("SubCategoryID", this.selectedSubCategory);
        formData.append("Document", file);
        formData.append("DocumentID", this.getDocumentID());

        console.log("Sending payload:", Object.fromEntries(formData.entries()));

        const response = await axios.post(
          "driver-management/insert-document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: 'Bearer ' + this.$store.state.token
            },
          }
        );

        this.data = response.data;
        this.emptyInfosAndAdd("Document uploaded successfully.")
        const fileInput = document.getElementById('myfile');
        if (fileInput) fileInput.value = '';

      } catch (err) {
        console.log("Error occurred:", err);
        console.log("Error Details:", err.response ? err.response.data : err.message);
        this.errors.push(`Error: ${err.message}`);
      } finally {
        this.loading = false;
      }
    },

    resetdriver() {
      this.searchQuery = ''
      this.selectedDriver = null
    },

    getDrivers() {
      axios
        .get('driver/active', {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.driverList = response.data.data;
          this.driverList = this.driverList.map((driver) => {
            driver.Name = driver.Name.replace(/,/g, "").trim();
            return driver;
          });
          console.log("drivers list", this.driverList);
        })
        .catch(error => {
          this.logErr(error);
        })
    },
    offboardDriver() {
      this.emptyErrorsAndInfos();

      if (!this.selectedDriver) {
        this.selectedSection = 'add';
        this.errors.push("Driver ID is required.");
        return;
      }

      if (!this.endDate) {
        this.selectedSection = 'add';
        this.errors.push("Please select a termination date.");
        this.isVisible = false;
        return;
      }

      const formData = new FormData();
      formData.append("endDate", this.endDate);

      console.log("Sending payload:", Object.fromEntries(formData.entries()));

      axios.post(`/driver-management/offboard-driver/${this.selectedDriver}`, formData, {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      })
        .then(() => {
          this.emptyInfosAndAdd("Driver offboarded successfully!");
          this.getDrivers();
        })
        .catch((error) => {
          console.error("Offboarding failed:", error);
          this.errors.push("Failed to offboard driver.");
        })
        .finally(() => {
          this.selectedSection = 'add';
          this.isVisible = false;
        });
    },
  },

  mounted() {
    this.getDrivers();
    window.onclick = (event) => {
      if (!event.target.closest('.search-container')) {
        this.shouldShow = false;
      }
    }
  }
};

</script>

<style scoped>
.container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 12px;
}

span {
  color: red;
}

h1 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 20px;
}

button {
  height: 45px;
  background: #4f83cc;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.3s ease;
  max-width: 200px;
}

button:hover {
  background: #0056b3;
}

.nav-buttons {
  display: flex;
  gap: 20px;
}

.nav-buttons button {
  flex: 1;
  text-align: center;
}

.active {
  background: #0056b3;
}

.form-group {
  margin-bottom: 15px;
}

label {
  font-size: 1rem;
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #444;
}

select {
  width: 250px;
  padding: 10px;
  border: 1px solid #080808;
  border-radius: 5px;
  font-size: 1rem;
  background: #f9f9f9;
}

/* Selection Section */
.selection-container1,
.selection-container2 {
  display: flex;
  gap: 20px;
  padding: 15px 0px;
  border-radius: 8px;
}

/* Results Display */
.results {
  background: #ffffff;
  padding: 15px;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 15px;
}

.results p {
  font-size: 0.95rem;
  margin: 5px 0;
}

.submit-btn {
  background: #0056b3;
  border: none;
  padding: 12px 20px;
  font-size: 1rem;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.submit-btn:hover {
  background: #012143;
}

.view-documents {
  margin-top: 20px;
}

.errors-list {
  list-style: none;
  padding: 0;
  color: red;
  margin-bottom: 20px;
}

.info-list {
  list-style: none;
  padding: 0;
  color: green;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .nav-buttons {
    flex-direction: column;
  }

  .selection-container {
    flex-direction: column;
  }
}

.search-input {
  width: 380px;
  padding: 10px;
  border: 1px solid #4f83cc;
  border-radius: 5px;
  font-size: 1rem;
  background: #f9f9f9;
  transition: border 0.3s ease;
}

.search-input:focus {
  border-color: #007bff;
  outline: none;
}

/* Search Results Dropdown */
.search-results {
  width: 380px;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.search-results li {
  padding: 10px;
  cursor: pointer;
  transition: background 0.4s ease;
}

.search-results li:hover {
  background: #4f83cc;
  color: white;
}

.span {
  position: absolute;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  z-index: 1;
}

.window {
  background: #fff;
  border-radius: 5px;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
</style>
